/** @jsx jsx */
import { css, jsx } from '@emotion/core';
import { Button, Divider } from 'antd';
import { navigate } from '@reach/router';
import { useAuth } from '~context/authContext';

function Header() {
  const { isAuthenticated, user, logout } = useAuth();

  const handleHomeClick = () => {
    navigate('/');
  };

  const containerStyle = css`
    display: flex;
    justify-content: ${isAuthenticated ? 'space-between' : 'center'};
    align-items: center;

    height: 3rem;
    width: 100%;
    @media (min-width: 50rem) {
      width: 75%;
      margin: 0 12.5%;
    }

    box-shadow: 2px 2px 3px 0px rgba(0, 0, 0, 0.3);
    border-radius: 0 0 3px 3px;
    padding: 0 2.5rem;

    font-size: 1.5rem;

    /* background-color: white;
    color: #0b2236; */
    background-color: #0277bd;
    color: white;
  `;

  const userContainerStyle = css`
    display: flex;
    justify-content: space-between;
    align-items: center;

    font-size: 0.9rem;
    font-weight: 500;
  `;

  return isAuthenticated ? (
    <div css={containerStyle}>
      <Button icon="home" onClick={handleHomeClick} />
      <div css={userContainerStyle}>
        {!!user && user.email}
        <Divider type="vertical" />
        <Button shape="circle" icon="logout" size="small" onClick={logout} ghost />
      </div>
    </div>
  ) : (
    <div css={containerStyle}>
      <b>NetConn Manager</b>
    </div>
  );
}

export default Header;
